/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import { FlexRow, FlexCol } from 'sarsaparilla';
import CostsTable from './CostsTable';

export default class ReservationSummary extends PureComponent {
    static propTypes = {
        cart: PropTypes.object,
        cartReservation: PropTypes.object,
        reservations: PropTypes.any,
        permit: PropTypes.object,
        totalGroupSize: PropTypes.number,
        calcFeePerMember: PropTypes.bool,
    };

    static defaultProps = {
        reservations: [],
        cart: {},
    };

    renderHuntDate(reservation) {
        const { permit } = this.props;
        const displayAvailabilityRange = permit?.components?.display_availability_range;
        const dateDisplay = displayAvailabilityRange
            ? `${gnoment(reservation.start_date).format('ddd, ll')} - ${gnoment(reservation.end_date).format('ddd, ll')}`
            : gnoment(reservation.start_date).format('ddd, ll');
        return dateDisplay;
    }

    render() {
        const { cart, cartReservation, reservations, totalGroupSize, calcFeePerMember } =
            this.props;
        if (!cartReservation) return null;

        const { cart_line_items: cartLineItems } = cartReservation;
        const noLineItemsText = cartLineItems
            ? undefined
            : 'There was an error getting pricing information for this reservation. Please try again later.';

        // build a new cart line items array with the total group size
        const cartLineItemsWithNewQty = cartLineItems?.map((item) => ({
            ...item,
            calc_qty:
                item.fee_type === 'USE' && calcFeePerMember
                    ? totalGroupSize
                    : item.quantity,
        }));

        const subtotal = cartLineItemsWithNewQty
            ?.map((item) => +item.unit_price * item.calc_qty)
            .reduce((memo, v) => memo + v, 0);
        const total = subtotal;

        // modified cart reservation with the new cart line items
        const newCartReservation = {
            ...cartReservation,
            cart_line_items: cartLineItemsWithNewQty,
        };

        return (
            <>
                <div className="rec-order-summary-item-price">
                    {reservations.map((reservation) => (
                        <FlexRow key={reservation.id} xs={12}>
                            <FlexCol>Hunt Date</FlexCol>
                            <FlexCol xs={12}>
                                <strong>{this.renderHuntDate(reservation)}</strong>
                            </FlexCol>
                        </FlexRow>
                    ))}
                </div>
                <CostsTable
                    {...cart}
                    reservations={[newCartReservation]}
                    subtotal={subtotal}
                    total={total}
                    noLineItemsText={noLineItemsText}
                />
            </>
        );
    }
}
